class VisaSlider {
    constructor() {
        new Swiper('.visa-slider__swiper', {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.visa-slider__next__btn',
                prevEl: '.visa-slider__prev__btn',
            },
        });
    }

}
new VisaSlider();